import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
// import { Tree, TreeNode } from 'react-organizational-chart';
import Breadcrumb from "../Components/Breadcrumb";
import UnderMaintanence from "./UnderMaintanence";
import AdmissionEnquiry from "./AdmissionEnquiry";
import ArrowIcon from "@mui/icons-material/DoubleArrow";
import newspaperAdvtPdf from "../assets/PDF/Admission Cap/A.Y.2026-27_ACAP-IL_Advt.pdf";
import vacancyPositionMatricMCA from "../assets/PDF/Admission Cap/MCA_seat_matrix.pdf";
import vacancyPositionMatricMBA from "../assets/PDF/Admission Cap/MBA_seat_matrix_vacancy.pdf";
import MeritListVacancyBCAPdf from "../assets/PDF/Admission Cap/Merit_List_vacancy_BCA_list.pdf";
import MeritListVacancyMCAPdf from "../assets/PDF/Admission Cap/Merit_MCA_ACAP_List_2.pdf";
import MeritListVacancyMBAPdf from "../assets/PDF/Admission Cap/Merit_list_vacancy_MBA_list.pdf";
import MeritListMgtMCAPdf from "../assets/PDF/Admission Cap/MCA_IL_Mgt_List_2.pdf";


// new changes
import Merit_List_MBA_ACAP from "../assets/PDF/Admission Cap/newChanges/Merit_List_MBA_ACAP.pdf";
import BCA_list from "../assets/PDF/Admission Cap/newChanges/BCA_list.pdf";
import Merit_List_MCA_ACAP from "../assets/PDF/Admission Cap/newChanges/Merit_List_MCA_ACAP.pdf";
import MCA_IL_List_2 from "../assets/PDF/Admission Cap/newChanges/MCA_IL_List_2.pdf";

const sidemenus = [
  {
    title: "Admission Process",
    url: null,
    children: [
      {
        title: "MBA",
        url: "/admission/MBA",
      },
      {
        title: "MCA",
        url: "/admission/MCA",
      },
      {
        title: "BCA",
        url: "/admission/BCA",
      },
      {
        title: "Ph.D",
        url: "/admission/PHD",
      },
    ],
  },
  {
    title: "Institute Level/Against CAP",
    url: null,
    children: [
      {
        title: "Information Brochure A.Y. 2026-27",
        url: "/admission/InformationBrochure",
      },
      {
        title: "Against CAP Notice-1",
        url: "/admission/AgainstCapNotice1",
      },
      {
        title: "Against CAP Notice-2",
        url: "/admission/AgainstCapNotice2",
      },
      {
        title: "Circular",
        url: "/admission/Circular",
      },
      {
        title: "Admission Schedule",
        url: "/admission/AdmissionSchedule",
      },
      {
        title: "Newspaper Advertisement",
        url: "/admission/NewspaperAdvertisement",
      },
      {
        title: "MBA",
        url: "/admission/AgainstCapMBA",
      },
      {
        title: "MCA",
        url: "/admission/AgainstCapMCA",
      },
      {
        title: "BCA",
        url: "/admission/AgainstCapBCA",
      },
      {
        title: "Provisional Vacancy Position for MCA",
        url: "/admission/VacancyPositionMCA",
      },
      {
        title: "Provisional Vacancy Position for MBA",
        url: "/admission/VacancyPositionMBA",
      },
      {
        title: "Merit List BCA students ACAP vacancy 2026-2027",
        url: "/admission/meritListVacancyBCA",
      },
      {
        title: "Merit List MCA students ACAP vacancy 2026-2027",
        url: "/admission/meritListVacancyMCA",
      },
      {
        title: "Merit List MBA students ACAP vacancy 2026-2027",
        url: "/admission/meritListVacancyMBA",
      },
         {
        title: "Merit List MCA students IL (Mgt) vacancy 2026-2027 ",
        url: "/admission/meritListMgtMCA",
      },
    ],
  },
  {
    title: "Eligibility",
    url: "/admission/Eligibility",
  },
  {
    title: "Documents",
    url: "/admission/Documents",
  },
  {
    title: "Fee Structure",
    url: "/admission/FeeStructure",
  },
  {
    title: "MIBS Prospectus",
    url: "/admission/Prospectus",
  },
  {
    title: "Contact For Admissions",
    url: "/admission/Contact",
  },
];

export default function Admission(props) {
  const location = useLocation();

  const [openParent, setOpenParent] = useState(() => {
    // Auto-open parent if current page is a child by url or pageName
    const foundByUrl = sidemenus.find(
      (menu) =>
        menu.children &&
        menu.children.some((child) => child.url === location.pathname),
    );
    if (foundByUrl) return foundByUrl.title;

    const found = sidemenus.find(
      (menu) =>
        menu.children &&
        menu.children.some(
          (child) => child.title.trim() === props.pageName.trim(),
        ),
    );
    return found ? found.title : null;
  });

  useEffect(() => {
    // Auto-expand parent on prop / location change (navbar navigation)
    const foundByUrl = sidemenus.find(
      (menu) =>
        menu.children &&
        menu.children.some((child) => child.url === location.pathname),
    );
    if (foundByUrl) {
      setOpenParent(foundByUrl.title);
    } else {
      sidemenus.forEach((menu) => {
        if (menu.children) {
          const isChildActive = menu.children.some(
            (child) => child.title.trim() === props.pageName.trim(),
          );
          if (isChildActive) setOpenParent(menu.title);
        }
      });
    }
    window.scrollTo(0, 0);
  }, [props.pageName, location.pathname]);

  const toggleParent = (title) => {
    setOpenParent((prev) => (prev === title ? null : title));
  };

  return (
    <>
      <Breadcrumb pageTitle={props.pageName} />
      <div className="container mt-3">
        <div className="row default-padding-bottom">
          {/* Sidebar */}
          <aside className="sideMenu col-lg-3">
            <div
              className="scroll-div"
              style={{ display: "flex", flexDirection: "column" }}
            >
              {sidemenus.map((menu, index) => {
                if (menu.children) {
                  return (
                    <div
                      key={index}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "10px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <a
                          onClick={(e) => {
                            e.preventDefault();
                            toggleParent(menu.title);
                          }}
                          style={{
                            flex: 1,
                            cursor: "pointer",
                            justifyContent: "space-between",
                          }}
                        >
                          {menu.title}
                          <span
                            style={{
                              cursor: "pointer",
                              padding: "0 8px",
                              fontSize: "20px",
                            }}
                          >
                            {openParent === menu.title ? "▲" : "▼"}
                          </span>
                        </a>
                      </div>
                      {openParent === menu.title && (
                        <div
                          style={{
                            paddingLeft: "12px",
                            borderLeft: "3px solid #ccc",
                            marginLeft: "8px",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                          }}
                        >
                          {menu.children.map((child, childIndex) => {
                            const isChildActive =
                              child.url === location.pathname ||
                              (props.pageName.trim() === child.title.trim() &&
                                openParent === menu.title);
                            return (
                              <Link
                                key={childIndex}
                                to={child.url}
                                className={isChildActive ? "active-menu" : ""}
                                style={{
                                  display: "block",
                                  fontSize: "0.9rem",
                                  wordBreak: "break-word",
                                  whiteSpace: "normal",
                                }}
                              >
                                ↳ {child.title}
                              </Link>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                }
                return (
                  <Link
                    key={index}
                    to={menu.url}
                    className={
                      menu.url === location.pathname ||
                      props.pageName.trim() === menu.title.trim()
                        ? "active-menu"
                        : ""
                    }
                  >
                    {menu.title}
                  </Link>
                );
              })}
            </div>
          </aside>

          {/* Content */}
          <div className="col-lg-9">
            <div className="px-lg-3 px-1">{props.pageContent}</div>
          </div>
        </div>
      </div>
    </>
  );
}

export function MBAAdmission() {
  return (
    <>
      <div className="text-justify">
        <h5 className="my-3 title-text">Sanctioned Intake Capacity : 120</h5>
        <h6 className="my-3 fw-bold">
          Procedure of Admission (CAP round) confirmation in PES MIBS
        </h6>
        <h5 className="my-3 title-text">Steps for Admission Process</h5>
        <h6 className="my-3 fw-bold">
          Step 1 : Verification of Allotment Letter
        </h6>
        <h6 className="my-3 fw-bold">Step 2 : Fill the Admission Form</h6>
        <h6 className="my-3 fw-bold">
          Step 3 : Verification of Original Documents
        </h6>
        <h6 className="my-3 fw-bold">
          Step 4 : Fill fee challan and deposit Institute fees
        </h6>
        <h6 className="my-3 fw-bold">
          Step 5 : Online Admission Confirmation (DTE Website)
        </h6>
        <h6 className="my-3 fw-bold">Step 6 : Final Submission</h6>
        <h6 className="my-3 fw-bold">Step 7 : Fill SPPU Eligibility form</h6>
        <p className="fw-bold m-0">
          For More Details, Please Refer Below Link:
        </p>
        <Link
          to={`https://cetcell.mahacet.org/`}
          style={{ color: "steelblue" }}
          target="_blank"
        >
          {" "}
          https://cetcell.mahacet.org/
        </Link>
      </div>
    </>
  );
}

export function MCAAdmission() {
  return (
    <>
      <div className="text-justify">
        <h5 className="my-3 title-text">Sanctioned Intake : 60</h5>
        <h6 className="my-3 fw-bold">
          Procedure of Admission (CAP round) confirmation in PES MIBS
        </h6>
        <h5 className="my-3 title-text">Steps for Admission Process</h5>
        <h6 className="my-3 fw-bold">
          Step 1 : Verification of Allotment Letter
        </h6>
        <h6 className="my-3 fw-bold">Step 2 : Fill the Admission Form</h6>
        <h6 className="my-3 fw-bold">
          Step 3 : Verification of Original Documents
        </h6>
        <h6 className="my-3 fw-bold">
          Step 4 : Fill fee challan and deposit Institute fees
        </h6>
        <h6 className="my-3 fw-bold">
          Step 5 : Online Admission Confirmation (DTE Website)
        </h6>
        <h6 className="my-3 fw-bold">Step 6 : Final Submission</h6>
        <h6 className="my-3 fw-bold">Step 7 : Fill SPPU Eligibility form</h6>
        <p className="fw-bold m-0">
          For More Details, Please Refer Below Link:
        </p>
        {/* <Link to={`https://mca2023.mahacet.org.in/cet2023/mca23/index.php?show=home`} target="_blank"> https://mca2023.mahacet.org.in/cet2023/mca23/index.php?show=home</Link> */}
        <Link
          to={`https://cetcell.mahacet.org/`}
          style={{ color: "steelblue" }}
          target="_blank"
        >
          {" "}
          https://cetcell.mahacet.org/
        </Link>
      </div>
    </>
  );
}

export function BCAAdmission() {
  return (
    <>
      <div className="text-justify">
        <h5 className="my-3 title-text">Sanctioned Intake : 60</h5>
        <h6 className="my-3 fw-bold">
          Procedure of Admission (CAP round) confirmation in PES MIBS
        </h6>
        <h5 className="my-3 title-text">Steps for Admission Process</h5>
        <h6 className="my-3 fw-bold">
          Step 1 : Verification of Allotment Letter
        </h6>
        <h6 className="my-3 fw-bold">Step 2 : Fill the Admission Form</h6>
        <h6 className="my-3 fw-bold">
          Step 3 : Verification of Original Documents
        </h6>
        <h6 className="my-3 fw-bold">
          Step 4 : Fill fee challan and deposit Institute fees
        </h6>
        <h6 className="my-3 fw-bold">
          Step 5 : Online Admission Confirmation (DTE Website)
        </h6>
        <h6 className="my-3 fw-bold">Step 6 : Final Submission</h6>
        <h6 className="my-3 fw-bold">Step 7 : Fill SPPU Eligibility form</h6>
        <p className="fw-bold m-0">
          For More Details, Please Refer Below Link:
        </p>
        {/* <Link to={`https://mca2023.mahacet.org.in/cet2023/mca23/index.php?show=home`} target="_blank"> https://mca2023.mahacet.org.in/cet2023/mca23/index.php?show=home</Link> */}
        <Link
          to={`https://cetcell.mahacet.org/`}
          style={{ color: "steelblue" }}
          target="_blank"
        >
          {" "}
          https://cetcell.mahacet.org/
        </Link>
        <h6>(Government of Maharashtra CET is compulsory for BCA Admission)</h6>
      </div>
    </>
  );
}

export function PHDAdmission() {
  return (
    <>
      <div className="text-justify">
        {/* <h5 className="my-3 title-text">PhD Admission Procedure</h5> */}
        <h5 className="my-3 title-text">Steps for Admission Process</h5>
        <h6 className="my-3 fw-bold">Step 1 : Apply for SPPU PET exam</h6>
        <h6 className="my-3 fw-bold">
          Step 2 : Selected Research center in online mode
        </h6>
        <h6 className="my-3 fw-bold">
          Step 3 : Present research Idea in research center
        </h6>
        <h6 className="my-3 fw-bold">Step 4 : Get the approval from SPPU</h6>
        <div style={{ margin: "10px" }}>
          {/* <div style={{ margin: '100px auto', maxWidth: '600px', padding: '20px 50px', backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)' }}> */}
          <p>For Ph.D Admission process</p>
          <Link
            to="https://bcud.unipune.ac.in/phd_entrance/applicant/login.aspx"
            target="_blank"
            style={{ color: "steelblue", wordWrap: "break-word" }}
          >
            visit:https://bcud.unipune.ac.in/phd_entrance/applicant/login.aspx.
          </Link>
        </div>
      </div>
    </>
  );
}

export function InformationBrochure() {
  return (
    <>
      <object
        data={
          process.env.PUBLIC_URL +
          "/assets/pdf/InformationBrochureAY2026_27.pdf"
        }
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link
            to={
              process.env.PUBLIC_URL +
              "/assets/pdf/InformationBrochureAY2026_27.pdf"
            }
          >
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function Eligibility() {
  return (
    <>
      <div className="text-justify">
        <h5 className="my-3 title-text">Eligibility for MBA</h5>
        <h6 className="my-3 fw-bold">
          Maharashtra State Candidature Candidates
        </h6>
        <ol type="i">
          <li>The Candidate should be an Indian National. </li>
          <li>
            Passed minimum three year duration Bachelor’s Degree awarded by any
            of the Universities recognized by University Grants Commission or
            Association of Indian Universities in any discipline with at least
            50% marks in aggregate or equivalent (at least 45% in case of
            candidates of backward class categories, Economically weaker section
            and Persons With Disability Candidates belonging to Maharashtra
            State only) or its equivalent.
          </li>
          <li>
            Obtained non zero score in CET conducted by the Competent Authority
            (MAHMBA/MMS- CET 2023).
          </li>
        </ol>

        <h6 className="my-3 fw-bold">
          All India Candidature Candidates, Union Territory of Jammu and Kashmir
          and Union Territory of Ladakh Migrant Candidature Candidates
        </h6>
        <ol type="i">
          <li>The Candidate should be an Indian National.</li>
          <li>
            Passed minimum Three year duration Bachelor's Degree awarded by the
            University recognized by University Grants Commission or Association
            of Indian Universities in any discipline with at least 50% marks in
            aggregate or equivalent (at least 45% in case of candidates of
            backward class categories, economically weaker section and Persons
            with Disability Candidates belonging to Maharashtra State only) or
            its equivalent.
          </li>
          <li>
            The candidate should have obtained non zero positive score in any
            one of the following examinations. - CET conducted by the Competent
            Authority or Common Admission Test conducted by Indian Institute of
            Management (CAT) or Common Management Aptitude Test Conducted by
            National Testing Agency (CMAT) or Xavier Aptitude Test conducted by
            Xavier School of Management Jamshedpur (XAT) or Entrance Test for
            Management Admissions conducted by the Association of Indian
            Management Schools (ATMA) or Management Aptitude Test Conducted by
            All India Management Association (MAT) or Graduate Management
            Aptitude Test Conducted by Graduate Management Admission Council,
            United States of America (GMAT).
          </li>
        </ol>

        <h5 className="my-3 mt-5 title-text">
          Eligibility Criteria for MCA 2023
        </h5>
        <h6 className="my-3 fw-bold">
          The candidate should fulfill the following eligibility criteria:
        </h6>
        <ol type="i">
          <li>The candidate should be an Indian National.</li>
          <li>
            The should have Passed B.C.A or B.Sc. (Computer Science) or B.Sc
            (IT) or B.E. (CSE) or B.Tech (CSE) or B.E. (IT) or B.Tech. (IT) or
            equivalent Degree and obtained at least 50% marks in aggregate (at
            least 45% in case of candidates of Backward Class categories,
            economically weaker section and Persons with Disability category
            belonging to Maharashtra State); Or (ii) The candidate should have
            any graduation degree (e.g : B.E. or B.Tech or B.Sc or B.Com or B.A.
            or B.Voc. etc) preferably with Mathematics at 10+2 Level or at
            Graduation Level(with additional bridge Courses as per the norms of
            the concerned University) and obtained at least 50% marks in
            aggregate (at least 45% in case of candidates of Reserved
            categories,Economically Weaker Section and Persons with Disability
            category belonging to Maharashtra State);(Candidates appearing for
            final year of qualifying examination are also eligible to appear for
            CET)
          </li>
        </ol>
        <h6 className="my-3 fw-bold">Note:</h6>
        <ul>
          <li>
            Aggregate marks means the grand total of marks obtained by the
            candidate in subjects on which the class declaration is made in the
            particular University from which the candidate is passing the
            qualifying examination.
          </li>
          <li>
            In case the candidates are awarded grades/CGPA instead of marks, the
            conversion of grades/CGPA to percentage of marks would be based on
            the procedure certified by the University/institution from where
            they have obtained the bachelor degree.
          </li>
          <li>
            The percentage of marks shall be calculated by rounding off to two
            places after decimal.
          </li>
          <li>
            The candidates belonging to SC, VJ/DT (NT (A)), NT (B), NT(C), NT
            (D), OBC, SBC categories should produce “Caste Validity Certificate”
            issued by Scrutiny Committee of Social Welfare Department and the
            Candidate belonging to ST category should submit “Tribe Validity
            Certificate” issued by Scrutiny Committee of Tribal Department and
            valid Non Creamy Layer certificate except SC, ST candidates at the
            time of verification of documents.
          </li>
        </ul>
      </div>
    </>
  );
}

export function Documents() {
  return (
    <>
      <div className="text-justify">
        <h5 className="my-3 title-text">
          Documents Required for MBA and MCA Admission
        </h5>
        <table>
          <thead>
            <tr>
              <th>Sr.No.</th>
              <th>Particulars</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>1.</td>
              <td>CAP Allotment Letter</td>
            </tr>
            <tr>
              <td>2.</td>
              <td>Score Card</td>
            </tr>
            <tr>
              <td>3.</td>
              <td>SSC Marks Statement</td>
            </tr>
            <tr>
              <td>4.</td>
              <td>HSC Marks Statement</td>
            </tr>
            <tr>
              <td>5.</td>
              <td>
                All statement of marks for the Bachelor’s Degree Examination
              </td>
            </tr>
            <tr>
              <td>6.</td>
              <td>College Leaving certificate (LC / TC)</td>
            </tr>
            <tr>
              <td>7.</td>
              <td>
                Migration Certificate (OTH & OMS Category Students) (if
                applicable)
              </td>
            </tr>
            <tr>
              <td>8.</td>
              <td>
                Domicile Certificate by permanent residence /Birth Cert/ School
                Leaving attested by School & College
              </td>
            </tr>
            <tr>
              <td>9.</td>
              <td>
                Certificate of Indian Nationality. In lieu of the “Certificate
                of Indian Nationality”/The School leaving Certificate /Indian
                Passport/ Birth Certificate
              </td>
            </tr>
            <tr>
              <td>10.</td>
              <td>GAP Certificate (If Applicable)</td>
            </tr>
            <tr>
              <td>11.</td>
              <td>Caste certificate (If Applicable)</td>
            </tr>
            <tr>
              <td>12.</td>
              <td>Caste / Tribe Validity certificate (If Applicable)</td>
            </tr>
            <tr>
              <td>13.</td>
              <td>
                Non-creamy Layer certificate valid up to 31st March 2024 (If
                Applicable)
              </td>
            </tr>
            <tr>
              <td>14.</td>
              <td>Income Certificate (If Applicable)</td>
            </tr>
            <tr>
              <td>15.</td>
              <td>EWS Certificate (if Applicable)</td>
            </tr>
            <tr>
              <td>16.</td>
              <td>Certificate of Handicap (if Applicable)</td>
            </tr>
            <tr>
              <td>17.</td>
              <td>
                Certificate in Proforma A,B,C,D,E,F,G, V as applicable in
                original
              </td>
            </tr>
            <tr>
              <td>18.</td>
              <td>Aadhar Card</td>
            </tr>
            <tr>
              <td>19.</td>
              <td>PAN Card</td>
            </tr>
            <tr>
              <td>20.</td>
              <td>Passport Size Photo</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}

export function FeeStructure() {
  return (
    <>
      <object
        // data="/assets/pdf/InformationGuidelines.pdf"
        data={process.env.PUBLIC_URL + "/assets/pdf/FeeStructure26_27.pdf"}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link
            to={process.env.PUBLIC_URL + "/assets/pdf/FeeStructure26_27.pdf"}
          >
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function MIBSProspectus() {
  return (
    <>
      <object
        // data="/assets/pdf/InformationGuidelines.pdf"
        data={
          process.env.PUBLIC_URL + "/assets/pdf/MIBS PROSPECTUS 2025-26 (1).pdf"
        }
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link
            to={
              process.env.PUBLIC_URL +
              "/assets/pdf/MIBS PROSPECTUS 2025-26 (1).pdf"
            }
          >
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function ContactAdmission() {
  return (
    <>
      <AdmissionEnquiry />
    </>
  );
}

// export function AgainstCapNotice1() {
//   return (
//     <>
//       <div className="text-justify">
//         <h5 className="my-3 title-text">Against Cap Notice-1</h5>
//         <p>Details will be updated soon.</p>
//       </div>
//     </>
//   );
// }

// export function AgainstCapNotice2() {
//   return (
//     <>
//       <div className="text-justify">
//         <h5 className="my-3 title-text">Against Cap Notice-2</h5>
//         <p>Details will be updated soon.</p>
//       </div>
//     </>
//   );
// }

export function AgainstCapNotice1() {
  return (
    <>
      <object
        data={process.env.PUBLIC_URL + "/assets/pdf/ACAPNOTICE1_2026.pdf"}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link
            to={process.env.PUBLIC_URL + "/assets/pdf/ACAPNOTICE1_2026.pdf"}
          >
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function AgainstCapNotice2() {
  return (
    <>
      <object
        data={process.env.PUBLIC_URL + "/assets/pdf/ACAPNOTICE2_2026.pdf"}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link
            to={process.env.PUBLIC_URL + "/assets/pdf/ACAPNOTICE2_2026.pdf"}
          >
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function Circular() {
  return (
    <>
      <object
        data={process.env.PUBLIC_URL + "/assets/pdf/Cut_off_circular.pdf"}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link
            to={process.env.PUBLIC_URL + "/assets/pdf/Cut_off_circular.pdf"}
          >
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function AdmissionSchedule() {
  return (
    <>
      <object
        data={
          process.env.PUBLIC_URL +
          "/assets/pdf/AdmissionSchedulleAY2026_27InstituteLevelACAP.pdf"
        }
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link
            to={
              process.env.PUBLIC_URL +
              "/assets/pdf/AdmissionSchedulleAY2026_27InstituteLevelACAP.pdf"
            }
          >
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function NewspaperAdvertisement() {
  return (
    <>
      <object
        data={newspaperAdvtPdf}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link to={newspaperAdvtPdf} target="_blank">
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function AgainstCapMBA() {
  return (
    <>
      <div className="text-justify">
        <h5 className="my-3 title-text">
          MBA Admission Against CAP / Institute Level
        </h5>
        <p className="my-3" style={{ fontSize: "16px", lineHeight: "1.6" }}>
          Invite applications for CET registered candidates for Online
          submission of Option Form for the Against CAP admissions,
        </p>
        <div className="my-4">
          <p className="fw-bold mb-2">
            For Online Submission of Option Form, Please Click Below Link:
          </p>
          <div className="d-flex align-items-center flex-wrap gap-2 my-2">
            <span className="fw-bold">
              Click <ArrowIcon className="mb-1" />
            </span>
            <a
              href="https://forms.gle/jjioUXxA9fB6b2jcA"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "steelblue", wordBreak: "break-all" }}
            >
              https://forms.gle/jjioUXxA9fB6b2jcA
            </a>
          </div>
          <div className="mt-3">
            <a
              href="https://forms.gle/jjioUXxA9fB6b2jcA"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button id="blinking-button" className="p-2 px-4">
                Fill MBA Option Form
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export function AgainstCapMCA() {
  return (
    <>
      <div className="text-justify">
        <h5 className="my-3 title-text">
          MCA Admission Against CAP / Institute Level
        </h5>
        <p className="my-3" style={{ fontSize: "16px", lineHeight: "1.6" }}>
          Invite applications for CET registered candidates for Online
          submission of Option Form for the Institute Level and Against CAP
          admissions.
        </p>
        <div className="my-4">
          <p className="fw-bold mb-2">
            For Online Submission of Option Form, Please Click Below Link:
          </p>
          <div className="d-flex align-items-center flex-wrap gap-2 my-2">
            <span className="fw-bold">
              Click <ArrowIcon className="mb-1" />
            </span>
            <a
              href="https://forms.gle/X5qtDTyyGsm8cPDh8"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "steelblue", wordBreak: "break-all" }}
            >
              https://forms.gle/X5qtDTyyGsm8cPDh8
            </a>
          </div>
          <div className="mt-3">
            <a
              href="https://forms.gle/X5qtDTyyGsm8cPDh8"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button id="blinking-button" className="p-2 px-4">
                Fill MCA Option Form
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export function AgainstCapBCA() {
  return (
    <>
      <div className="text-justify">
        <h5 className="my-3 title-text">
          BCA Admission Against CAP / Institute Level
        </h5>
        <p className="my-3" style={{ fontSize: "16px", lineHeight: "1.6" }}>
          Invite applications for CET registered candidates for Online
          submission of Option Form for the Against CAP admissions.
        </p>
        <div className="my-4">
          <p className="fw-bold mb-2">
            For Online Submission of Option Form, Please Click Below Link:
          </p>
          <div className="d-flex align-items-center flex-wrap gap-2 my-2">
            <span className="fw-bold">
              Click <ArrowIcon className="mb-1" />
            </span>
            <a
              href="https://forms.gle/4avYsT8JRx5JKFmZA"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "steelblue", wordBreak: "break-all" }}
            >
              https://forms.gle/4avYsT8JRx5JKFmZA
            </a>
          </div>
          <div className="mt-3">
            <a
              href="https://forms.gle/4avYsT8JRx5JKFmZA"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button id="blinking-button" className="p-2 px-4">
                Fill BCA Option Form
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
}

export function VacancyPositionMCA() {
  return (
    <>
      <object
        data={vacancyPositionMatricMCA}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link to={vacancyPositionMatricMCA} target="_blank">
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function VacancyPositionMBA() {
  return (
    <>
      <object
        data={vacancyPositionMatricMBA}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link to={vacancyPositionMatricMBA} target="_blank">
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function MeritListVacancyBCA() {
  return (
    <>
      <object
        data={BCA_list}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link to={BCA_list} target="_blank">
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function MeritListVacancyMCA() {
  return (
    <>
      <object
        data={Merit_List_MCA_ACAP}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link to={Merit_List_MCA_ACAP} target="_blank">
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function MeritListVacancyMBA() {
  return (
    <>
      <object
        data={Merit_List_MBA_ACAP}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link to={Merit_List_MBA_ACAP} target="_blank">
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

export function MeritListMgtMCA() {
  return (
    <>
      <object
        data={MCA_IL_List_2}
        type="application/pdf"
        width="100%"
        height={800}
      >
        <p>Your web browser doesn't have a PDF plugin.</p>
        <p>
          Instead you can{" "}
          <Link to={MCA_IL_List_2} target="_blank">
            {" "}
            click here to download the PDF file.
          </Link>
        </p>
      </object>
    </>
  );
}

